export default __webpack_public_path__ + "static/media/lantern.81257ab7.svg";